import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.262 4.012a.25.25 0 0 0-.25.25L4 10.835c0 .067.026.13.073.177l9 9a.25.25 0 0 0 .353 0l6.586-6.586a.25.25 0 0 0 0-.354l-9-8.999A.25.25 0 0 0 10.836 4zm-1.75.247A1.75 1.75 0 0 1 4.26 2.512l6.574-.012c.465 0 .911.184 1.24.513l9 8.999a1.75 1.75 0 0 1 0 2.474l-6.586 6.586a1.75 1.75 0 0 1-2.475 0l-9-8.999a1.75 1.75 0 0 1-.512-1.24zm4.737 3.99a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }